import CheckoutPaymentMethods from '../Checkout.PaymentMethods';
import RenderCheckoutStorePickup from './RenderCheckoutStorePickup';
import React, {useEffect, useState} from 'react';
import {
  CHECKOUT_KLARNA_PAYMENT,
  CHECKOUT_PICK_UP_PAYMENT,
} from './CheckoutConst';

const RenderPaymentMethodsSection = ({
  checkout,
  setPaymentAndDelivery,
  setSelectedReseller,
}) => {
  const [filteredPaymentMethods, setFilteredPaymentMethods] = useState([])
  useEffect(() => {
    const tempMethods = [];
    for (let ogMethod of paymentMethods) {
      const method = {...ogMethod}
      if (method.id === CHECKOUT_KLARNA_PAYMENT) {
        method.formattedPrice =
            price.toFixed(2) + ' ' + orderCurrency.toUpperCase();
        tempMethods.push({
          ...method,
          translateKeyForName: 'checkout.payment_select.klarna_pay',
          translateKeyForDescription: 'checkout.payment_select.shipping_from',
          icon: 'klarnaPayIcon',
        });
        method.translateKeyForName = 'checkout.payment_select.klarna_pay';
        method.translateKeyForDescription = 'checkout.payment_select.shipping_from';
        method.icon = 'klarnaPayIcon';
      }
      if (method.id === CHECKOUT_PICK_UP_PAYMENT) {
        tempMethods.push({
          ...method,
          translateKeyForName: 'checkout.payment_select.direct_pay',
          translateKeyForDescription: 'checkout.payment_select.free_shipping',
          icon: 'directPayIcon',
        });
      }
    }

    setFilteredPaymentMethods(tempMethods);
  }, [checkout])

  const { payload, errors = {} } = checkout;
  const { orderCurrency, paymentMethods, klarnaSelectedShippingOption, kssCost } =
    payload;

  const price =
    klarnaSelectedShippingOption && klarnaSelectedShippingOption.price
      ? klarnaSelectedShippingOption.price / 100
      : kssCost;

  return (
    <>
      <CheckoutPaymentMethods
        paymentMethods={filteredPaymentMethods}
        selectedId={payload.selectedPaymentMethod}
        pickupMethodId={CHECKOUT_PICK_UP_PAYMENT}
        onChange={setPaymentAndDelivery}
      />
      {payload.selectedPaymentMethod == CHECKOUT_PICK_UP_PAYMENT && (
        <RenderCheckoutStorePickup
          checkout={checkout}
          setSelectedReseller={setSelectedReseller}
        />
      )}
      {errors['selectedPaymentMethod'] && (
        <span className="form__validator--error form__validator--top-narrow">
          {errors['selectedPaymentMethod'][0]}
        </span>
      )}
    </>
  );
};

export default RenderPaymentMethodsSection;
